import {
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import { message } from 'antd';

import { getExistingIntegrations, updateConfigStatus } from '@api/serviceIntegrations';
import { autoRequest } from '@api/createRequestStore';

import * as actions from './actions';
import * as types from './types';
import { actionSelector } from './selectors';

function* fetching() {
  try {
    yield put(actions.fetching());
    yield autoRequest(getExistingIntegrations, types.SCOPE);
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* initRequest() {
  yield put(actions.init());
}

function* updateStatus() {
  const { selectedConfig, actionType } = yield select(actionSelector);
  const payload = {
    id: selectedConfig,
    payload: {
      configuration: {
        state: actionType,
      },
    },
  };
  try {
    yield autoRequest(updateConfigStatus, types.SCOPE, payload);
    yield put(actions.fetchData());
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchFetching() {
  yield takeLatest([
    types.FETCH_DATA,
  ], fetching);
}

function* watchUpdateStatus() {
  yield takeLatest([
    types.UPDATE_CONFIG_STATUS,
  ], updateStatus);
}

export default [watchInitRequest,
  watchFetching,
  watchUpdateStatus];
